import {Injectable, signal} from '@angular/core';

/** Cross-shell profile display bits without a full store. */
@Injectable({
  providedIn: 'root',
})
export class AccountProfileState {
  readonly avatarUrl = signal<string | undefined>(undefined);
  readonly fullName = signal('');
}
